// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/index.css
// module id = 442
// module chunks = 55